import { formatearFechaLuxon } from "../../utils/formatearFecha"
import MotivoRechazo from "../domain/MotivoRechazo"
import EstadoObservacion from "../domain/EstadoObservacion"
import { Observacion, ObservacionItem } from "../domain/Observacion"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class ObservacionService {
  constructor() {
    this.apiService = new ApiServiceAdapter()
  }

  async getListObservaciones(fechaDesde, fechaHasta, idJuicio, nroExpediente, caratula, observacion, idDelegacion, nroSiniestro, idProfesional, idEstadoObservacion, idTipoMotivoRechazo) {
    let listadoObservaciones

    const fechaDesdeFormateada = fechaDesde ? formatearFechaLuxon(fechaDesde, 'yyyy-MM-dd') : ""
    const fechaHastaFormateada = fechaHasta ? formatearFechaLuxon(fechaHasta, 'yyyy-MM-dd') : ""
    const nroSiniestroFormateado = (nroSiniestro === '' || !nroSiniestro) ? -1 : nroSiniestro
    const idDelegacionFormateado = (idDelegacion === '' || !idDelegacion) ? -1 : idDelegacion
    const idEstadoObservacionFormateado = (idEstadoObservacion == -2) ? -1 : idEstadoObservacion
    const idTipoMotivoRechazoFormateado = (idTipoMotivoRechazo == -2) ? -1 : idTipoMotivoRechazo

    try {
      const observacionesData = await this.apiService.fetchObservaciones(fechaDesdeFormateada, fechaHastaFormateada, idJuicio, nroExpediente, caratula, observacion, idDelegacionFormateado, nroSiniestroFormateado, idProfesional, idEstadoObservacionFormateado, idTipoMotivoRechazoFormateado)

      listadoObservaciones = !observacionesData ? [] : observacionesData.map(
        (obs) =>
          new ObservacionItem(
            obs.idObservacion,
            obs.fechaIngreso,
            formatearFechaLuxon(obs.fechaIngreso, 'dd/MM/yyyy'),
            obs.descripcionObservacion,
            obs.caratula, obs.idJuicio,
            obs.nroExpediente,
            obs.nroSiniestro,
            obs.apellidoTrabajador,
            obs.nombreTrabajador,
            obs.tipoProceso,
            obs.estado,
            obs.motivoRechazo
          ))
    } catch (err) {
      listadoObservaciones = []
    }

    return listadoObservaciones
  }

  async altaObservacionJuicio(observacion, archivos) {
    let resultadoInsert

    try {

      const formData = new FormData();

      const data = {
        "nroJuicio": observacion.nroJuicio,
         "observacion": observacion.observacion,
         "fecha": formatearFechaLuxon(observacion.fecha,"dd-MM-yyyy HH:mm:ss"),
         "documentos": observacion.documentos
      }

      archivos && archivos.forEach((file, index) => {
        formData.append(`archivos`, file);
      });

      formData.append('data', JSON.stringify(data));

      //Inspeccionar FormData
      // for (let pair of formData.entries()) {
      //   console.log(pair[0], pair[1]);
      // }
      // console.log(data);
      // console.log(archivos)

      resultadoInsert = await this.apiService.fetchAltaObservacion(formData)

    }
    catch (err) {
      console.log(err)
    }
    //return "rdo"
    return resultadoInsert
  }

  async getObservacionId(idObservacion) {
    let observacion = null;

    try {
      const observacionData = await this.apiService.fetchObservacionPorId(idObservacion);

      if (observacionData) {
        observacion = new Observacion(
          observacionData.intIdObservacionLegal,
          observacionData.varObservacion,
          observacionData.varMail
        );
      }
    } catch (err) {
      observacion = null;
    }

    return observacion;
  }

  async getMotivosRechazo() {
    const motivosData = await this.apiService.fetchMotivosRechazo()

    const listadoMotivos = motivosData.map(
      (motivo) =>
        new MotivoRechazo(
          motivo.intIdTipoMotivoRechazo,
          motivo.varDescripcion
        )
    )

    return listadoMotivos
  }
  async getEstadosObservacion() {
    const estadosData = await this.apiService.fetchEstadosObservacion()

    const listadoEstados = estadosData.map(
      (estado) =>
        new EstadoObservacion(
          estado.intIdEstado,
          estado.varDescripcion
        )
    )

    return listadoEstados
  }

  async getObservacionesReingenieria(nroJuicio, cuit) {

    try {
      const observacionesData = await this.apiService.fetchObservacionesByIdReingenieria(nroJuicio, cuit);

      if (!observacionesData || !observacionesData.succeeded) {
        return null;
      }

      return observacionesData

    } catch (err) {
      return null;
    }
  }

}

export default ObservacionService
